import { HistoryFieldDescriptor } from '../../components/evidence/history-evidence/history-types';
import { coordinatesValueMapper } from '../../components/evidence/history-evidence/history-utils';

export function useHistoryDescriptors(): HistoryFieldDescriptor[] {
  return [
    {
      key: 'name',
      label: 'Název zdroje',
    },
    {
      key: 'sourceId',
      label: 'Číslo zdroje',
    },
    {
      key: 'sourceCategory',
      label: 'Zařazení zdroje',
    },
    {
      key: 'determinationMethod',
      label: 'Způsob určení minimální vzdálenosti',
    },
    {
      key: 'exemptFromMinDistances',
      label: 'Výjimka z MV',
    },
    {
      key: 'ovzFacility',
      label: 'Provozovna OVZ',
    },
    {
      key: 'active',
      label: 'Aktivní',
    },
    {
      key: 'wgs84Coordinates.lat',
      label: 'Zeměpisná šířka',
      valueMapper: coordinatesValueMapper,
    },
    {
      key: 'wgs84Coordinates.lon',
      label: 'Zeměpisná délka',
      valueMapper: coordinatesValueMapper,
    },
    {
      key: 'note',
      label: 'Poznámky',
    },
    {
      key: 'validTo',
      label: 'Platnost do',
    },
    {
      key: 'validFrom',
      label: 'Platnost od',
    },
  ];
}
